// extracted by mini-css-extract-plugin
export var text = "_82-0";